import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      gap: 24,
      padding: `${rem(40)} ${rem(16)}`,
      [theme.fn.largerThan('sm')]: {
        padding: 48,
      },
    },
    body: {},
    header: {
      gap: 12,
      [theme.fn.largerThan('sm')]: {
        gap: 24,
      },
    },
  }
})
